import { styled, TextField } from "@mui/material";
import pxToRem from "theme/base/pxToRem";

export const StyledTextField = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    borderRadius: pxToRem(10),
    "& fieldset": {
      border: `1px solid ${theme.palette.colorsBase.blue_8}`,
    },
    "&:hover fieldset": {
      border: `1px solid ${theme.palette.stroke.strokeBrand}`,
    },
    "&.Mui-focused fieldset": {
      border: `1px solid ${theme.palette.colorsBase.blue_8}`,
    },
  },
  "& label": {
    color: `${theme.palette.colorsBase.gray_6} !important`,
  },
}));
